import React from 'react';
import PropTypes from 'prop-types';

/**
 * TabLink - A wrapper that renders a standard HTML a element for Bulma tabs
 * 
 * This component accepts the same props as Bloomer TabLink for easy migration
 */
const TabLink = ({
  className,
  style,
  onClick,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = [];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <a 
      className={getClassNames()} 
      style={style}
      onClick={onClick}
      {...props}
    >
      {children}
    </a>
  );
};

TabLink.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node
};

TabLink.defaultProps = {
  className: '',
  style: {},
  onClick: () => {},
  children: null
};

export default TabLink;
